export interface VersionedDocument {
  id: string;
  reference?: string;
  version_major?: number;
  version_minor?: number;
}

/**
 * Filters an array of versioned documents so that only the latest version
 * (highest major → highest minor) per reference is returned.
 * If `reference` is missing, the `id` is used as fallback key (safe default).
 */
export function filterLatestDocuments<T extends VersionedDocument>(docs: T[]): T[] {
  const latestByRef = new Map<string, T>();

  for (const doc of docs) {
    const key = doc.reference || doc.id;
    const existing = latestByRef.get(key);

    if (!existing) {
      latestByRef.set(key, doc);
      continue;
    }

    const [mA, mB] = [doc.version_major ?? 0, existing.version_major ?? 0];
    const [nA, nB] = [doc.version_minor ?? 0, existing.version_minor ?? 0];

    if (mA > mB || (mA === mB && nA > nB)) {
      latestByRef.set(key, doc);
    }
  }

  return Array.from(latestByRef.values());
} 